<div class="zn-import-errors-modal">
  <zn-alert
    type="error"
    [title]="localizationResource.LanguageService + '::ZnExcelImportErrorsModalLoadFailedTitle' | abpLocalization"
    [text]="fileName()"
  ></zn-alert>

  <div class="zn-import-errors-toolbar">
    <p class="zn-error-count">
      {{ localizationResource.LanguageService + '::ZnExcelImportErrorsModalErrorCount' | abpLocalization }}: {{ errorCount() }}
    </p>
    <zn-button
      type="secondary"
      iconLeft="bi bi-file-earmark-excel"
      [label]="localizationResource.LanguageService + '::ZnExcelImportErrorsModalExportToExcel' | abpLocalization"
      [loading]="exportLoading()"
      (clicked)="onExport()"
    ></zn-button>
  </div>

  <div class="zn-search-field">
    <i class="bi bi-search"></i>
    <input
      type="text"
      [formControl]="searchControl"
      [placeholder]="localizationResource.LanguageService + '::ZnExcelImportErrorsModalSearchPlaceholder' | abpLocalization"
    />
  </div>

  <app-search-result-table
    gridId="excel-import-errors-grid"
    [columnDefinitions]="tableColumns"
    [dataset]="tableDataset()"
    [extraOptions]="tableOptions"
  ></app-search-result-table>

  @if (exportError()) {
    <zn-alert
      type="error"
      [title]="exportError()"
    ></zn-alert>
  }
</div>
